const VERSION_STATUS: boolean = window.location.hostname.search('localhost') === -1;
const BETA_VERSION: boolean = window.location.hostname.search('beta') === -1;
const ARK_VERSION: boolean = window.location.hostname.search('4rk') === -1;
const MOBILE_VERSION: boolean = window.location.hostname.search('192.168.1.85') === -1;

// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = VERSION_STATUS ? 'https://panel.mahi20.4rk.ir/' : 'http://localhost/sanam/';
// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = 'https://api.dr20.net/';
export const BASE_SITE = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'https://api.dr20.org/' : 'https://api.dr20.org/';
export const WEBSITE = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'https://dr20.org/' : 'https://dr20.org/';
// const BASE_API = VERSION_STATUS ? 'api/v1/' : 'api/beta/';
const BASE_API = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'v1/' : 'v1/';

export const LOGIN = BASE_API + 'users/login'; //mobile
export const USERS_ACTIVATION_POST = BASE_API + 'users/activation'; // code,mobile
export const INITIAL_DATA = BASE_API + 'initial-data'; //Authorization
export const EDIT_MEDICAL_RECORDS_1 = BASE_API + 'edit-medical-records-1'; // Authorization | hasSpecialDisease, diseaseName
export const EDIT_MEDICAL_RECORDS_2 = BASE_API + 'edit-medical-records-2'; // Authorization | hasSpecialMedication, medicationName
export const EDIT_MEDICAL_RECORDS_3 = BASE_API + 'edit-medical-records-3'; // Authorization | hasDrugAllergy, allergyDrugName
export const EDIT_MEDICAL_RECORDS_4 = BASE_API + 'edit-medical-records-4'; // Authorization | nationalCode, insuranceId
export const VISIT_REQUEST = BASE_API + 'visit-request'; // Authorization | doctorType, description
export const API_MAIN = BASE_API + 'main'; 
export const EDIT_PERSONAL_INFO = BASE_API + 'users/edit-personal-info'; 
export const USERS_LOGOUT_GET = BASE_API + 'users/logout';
export const VIP_SERVICES_REQUEST = BASE_API + 'vip-services-request';
export const SUGGESTIONS = BASE_API + 'suggestions';
export const SURGURY_CONSULTATION = BASE_API + 'surgury-consultation';
export const ELITE_DOCTORS_MEMBERSHIP = BASE_API + 'elite-doctors-membership';





export const CHECK_LOGIN_GET = BASE_API + 'users/check_login';
export const GET_CAPTCHA_IMAGE = BASE_API + 'users/create_captcha';
export const LOGIN_POST = BASE_API + 'users/login'; //mobile
export const VALIDATE_USER_BY_BARCODE = BASE_API + 'cashiers/validate_user_by_barcode'; //mobile
export const SEND_BUY_CODE_TO_USER = BASE_API + 'cashiers/send_code_to_user'; //mobile
export const VALIDATE_USER_BY_SMS = BASE_API + 'cashiers/validate_user'; //mobile
export const ADD_TRANS_POST = BASE_API + 'cashiers/add_trans'; 
export const TRANS_LIST_GET = BASE_API + 'cashiers/trans';
export const ACCUMULATIVE_TRANS_GET = BASE_API + 'cashiers/accumulative';
export const SETTLEMENTS_GET = BASE_API + 'cashiers/settlements';
export const GET_CASHIERS_OF_BRANCH = BASE_API + 'cashiers/get_cashiers_by_branch';
export const EDIT_FACTOR_NUM = BASE_API + 'cashiers/edit_factor_num';
export const REJECT_INSTALLMENTS_FACTOR = BASE_API + 'cashiers/reject_installments_factor';
export const PRINT_TRANS_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/print/';
export const EXCEL_EXPORT_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/excel_export/';
export const PDF_EXPORT_EXTERNAL_LINK = BASE_SITE + BASE_API + 'cashiers/pdf_export/';
export const INSTALLMENTS_FACTOR_GET = BASE_API + 'cashiers/installments_factor';
export const ACCEPT_INSTALLMENTS_FACTOR_POST = BASE_API + 'cashiers/accept_installments_factor';
export const CHECK_INSTALLMENTS_CODE = BASE_API + 'cashiers/validate_installments_barcode';
